export const CANCELLED = 'cancelled';
export const WAITING = 'payment_waiting';
export const REFUNDS = 'waiting_for_refund';
export const PROCESSING = 'payment_processing';
export const BOOKED = 'booked';
